// Form validation for Ticket Status form
import { plaintextValidator } from '../fields';

const config = {};

export default {
  subject: plaintextValidator({ mandatory: true }),
  description: plaintextValidator(config),
  to: {
    array: {
      presence: {
        allowEmpty: false
      }
    }
  }
  // to: {
  //   array: {
  //     conditionConfigs: {
  //       length: {
  //         minimum: 1,
  //         tooShort: 'Need atleast one mail id'
  //       }
  //     }
  //   }
  // }
};
